import * as yup from "yup";
import { filterSiteCoreKeys } from "../../../components/searchFilters/siteCore/SiteCoreKeys";
import {
  INPUT_LIMIT,
  MIN_FILTER_NAME_LENGTH,
  REGEX_NOT_NAME_NUMBER_AND_DASHES,
} from "../../../helpers/constants";
import { commonSiteCoreKeys } from "../../../helpers/constants/siteCoreKeys";
import {
  KeyValueMap,
  StringFunction,
} from "../../../redux/slices/appState/models";
import { ClientSearchFormKey, ClientSearchSaveFilterFormKey } from "./Models";
import { specialCharactersNotAllowedValidationForOptionalField } from "../../../helpers/constants/commonValidationSchemaUtils";


export const ClientSearchValidationSchema = (
  fetchValidationMessage: (key: string, replacements?: KeyValueMap) => string,
  commonValidationMessages: KeyValueMap,
) =>
  yup.object().shape({
    [ClientSearchFormKey.companyName]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ClientSearchFormKey.companyNameFilter]: yup.string().default(""),
    [ClientSearchFormKey.clientCodeFilter]: yup.string().default(""),
    [ClientSearchFormKey.clientType]: yup.string().default(""),
    [ClientSearchFormKey.clientCode]: yup
      .string()
      .optional()
      .matches(
        INPUT_LIMIT.ALPHA_NUMERIC,
        fetchValidationMessage(commonSiteCoreKeys.alphanumericFieldValidator),
      )
      .default(""),
    [ClientSearchFormKey.country]: yup.string().default(""),
    [ClientSearchFormKey.cityFilter]: yup.string().default(""),
    [ClientSearchFormKey.city]: 
      specialCharactersNotAllowedValidationForOptionalField(
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      )
      .default(""),
    [ClientSearchFormKey.status]: yup.string().default(""),
  });

export const ClientSearchSaveFilterValidationSchema = (
  array: { name: string }[],
  fetchValidationMessage: (key: string, replacements?: KeyValueMap) => string,
  fetchFilterPopupLabel: StringFunction,
) =>
  yup.object().shape({
    [ClientSearchSaveFilterFormKey.filterName]: yup
      .string()
      .required(
        fetchValidationMessage(commonSiteCoreKeys.enterFieldValueValidator, {
          LABELNAME: fetchFilterPopupLabel(
            filterSiteCoreKeys.filterName,
          ).toLowerCase(),
        }),
      )
      .min(
        MIN_FILTER_NAME_LENGTH,
        fetchFilterPopupLabel(
          filterSiteCoreKeys.filterNameMustBeAtLeast3Characters,
        ),
      )
      .matches(
        REGEX_NOT_NAME_NUMBER_AND_DASHES,
        fetchValidationMessage(commonSiteCoreKeys.specialCharNotAllowed),
      )
      .test(
        "unique-filter-name",
        fetchFilterPopupLabel(
          filterSiteCoreKeys.filterNameAlreadyExistsValidation,
        ),
        (value) => {
          if (
            array?.filter(
              (item: { name: string }) =>
                item.name.toLowerCase() === value.toLowerCase(),
            ).length > 0
          ) {
            return false;
          }
          return true;
        },
      ),
  });
